import styled from 'styled-components';
import { COLORS } from 'apps/web_forms/utils/constants';

// TODO: This was previously being imported from the stylsheet. I think a better
// way to handle this would be to set the font size as a CSS Custom Property and
// access it that way.
const rootFontSize = '18px';
const rootFontSizePixels = parseInt(rootFontSize, 10);
const notificationBarHeightEms = 50 / rootFontSizePixels;
const notificationBarHeight = `${notificationBarHeightEms.toFixed(3)}em`;

const verticalCenterTrick = `
  margin: 0;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

// Could use improvement, but good enough for now
export const NotificationBarDiv = styled.div`
  position: sticky;
  display: flex;
  z-index: 12;
  justify-content: center;
  align-items: center;
  height: ${notificationBarHeight};
  top: 0;
  left: 0;
  width: calc(100% + 2 * (${(props) => props.reactWrapperPadding}));
  margin: 0 -${(props) => props.reactWrapperPadding};
  margin-top: -2em;
  background-color: white;
  border-bottom: 2px solid ${COLORS.borderGrey};
  &.success {
    border-color: #c3e6cb;
    background-color: #d4edda;
    color: #155724;
  }
  &.error {
    color: #721c24;
    border-color: #f5c6cb;
    background-color: #f8d7da;
  }
  &.warning {
    color: #736c1d;
    border-color: #f5f1c6;
    background-color: #f7f5d7;
  }

  .icon-adjustment {
    font-size: 15px;
    position: relative;
    top: 2px;
  }

  .badge-adjustment {
    ${verticalCenterTrick}
  }

  .button-adjustment {
    ${verticalCenterTrick}
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  padding: 0 ${(props) => props.sidePadding};
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: 1em;
`;

export const MainTextP = styled.p`
  line-height: ${notificationBarHeight};
`;

export const LeftWrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1em;
`;

export const LeftSectionDiv = styled.div``;

export const RightSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
